import RetryAction from '@/classes/SubmissionActions/RetryAction'
import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import type { SubmissionAction } from '@/classes/SubmissionStatuses/types'
import type { SubmissionChannel } from '@/services/types'
import { DateTime } from 'luxon'

export class FailedSendStatus implements StatusObject {
	constructor(
		private vendorName: string,
		private channels: SubmissionChannel[]
	) {}

	getVendorName(): string {
		return this.vendorName
	}

	getUpdatedAt() {
		return DateTime.now().toISODate()
	}

	getActions(): Array<SubmissionAction> {
		return [new RetryAction(this.channels)]
	}

	getStatusText() {
		return 'Send Failed'
	}

	getToolTipText() {
		return {
			title: 'Send Failed',
			body: `We were unable to send this packet to ${this.vendorName}. Please retry the submission. If retry doesn't resolve the issue please contact salesstudio@precoa.com`,
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
